var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowBack = function SvgArrowBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#828D99",
    fillRule: "evenodd",
    d: "M8.485 2.93A1.421 1.421 0 0 0 6.484.912l-2.73 2.706C2.736 4.625 1.89 5.465 1.285 6.217.652 7.006.17 7.835.042 8.845a5.2 5.2 0 0 0 0 1.31c.128 1.01.61 1.84 1.244 2.628.604.752 1.451 1.592 2.467 2.599l2.73 2.706a1.421 1.421 0 0 0 2.002-2.018L5.812 13.42c-1.089-1.08-1.82-1.806-2.31-2.417l-.065-.083h13.142a1.421 1.421 0 0 0 0-2.842H3.437l.065-.083c.49-.61 1.221-1.337 2.31-2.417z",
    clipRule: "evenodd"
  })));
};
export { SvgArrowBack as ReactComponent };